const maxDateValue = 8640000000000000;

export const sortString = (a, b) => {
  return String(a ?? "").localeCompare(String(b ?? ""), undefined, {
    numeric: true,
    sensitivity: "base",
  });
};

export const sortNumber = (a, b) => {
  const numA = parseFloat(a) || 0;
  const numB = parseFloat(b) || 0;
  return numA - numB;
};

export const sortDate = (nullsLast) => {
  const nullValue = nullsLast ? maxDateValue : -maxDateValue;
  return (a, b) => {
    const dateA = isNaN(Date.parse(a)) ? new Date(nullValue) : new Date(a);
    const dateB = isNaN(Date.parse(b)) ? new Date(nullValue) : new Date(b);
    return dateA - dateB;
  };
};

export const sortFunctions = {
  string: sortString,
  number: sortNumber,
  date: sortDate(false),
};
